import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MasterdataService {
  // *-------------loading hendaling --------------*
  private onDemandUseData = new Subject<any>()
  shareData$ = this.onDemandUseData.asObservable()
  constructor(private http: HttpClient) {

  }

  sendData(Data: any) {
    this.onDemandUseData.next(Data)
  }
  //  *---------------Masterdata Legal Entity-----------------*
  getLegalEntityList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/legal/entity/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/legal/entity/list`, body);
    }
  }
  getLegaEntityDropdowns(){
    return this.http.get<any>(environment.baseApiUrl+'master/v1/dropdown/legal-entities');
  }
  postLegalEntity(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/legal/entity', body);
  }
  deleteLegalEntity(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/legal/entity/${id}`);
  }
  updateLegalEntity(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/legal/entity/${id}`, body);
  }

   //  *---------------Masterdata Legal Entity-----------------*
  getLocalGlobalFieldConfigList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/global/field/Config/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/global/field/Config/list`, body);
    }
  }
  postLocalGlobalFieldConfig(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/global/field/Config', body);
  }
  deleteLocalGlobalFieldConfig(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/global/field/Config/${id}`);
  }
  updateLocalGlobalFieldConfig(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/global/field/Config/${id}`, body);
  }


  //  *---------------Masterdata Country-----------------*
  getCountryList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/country/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/country/list`, body);
    }
  }
  postCountry(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/country', body);
  }
  deleteCountry(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/country/${id}`);
  }
  updateCountry(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/country/${id}`, body);
  }
  //  *---------------Masterdata Currency-----------------*
  getCurrency(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/currency/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/currency/list`, body);
    }
  }
  postCurrency(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/currency', body);
  }
  deleteCurrency(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/currency/${id}`);
  }
  updateCurrency(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/currency/${id}`, body);
  }
  //  *---------------Masterdata Sales Tax-----------------*
  getSalesTaxList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/sales/tax-groups/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/sales/tax-groups/list`, body);
    }
  }

  postSalesTaxList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/sales/tax-groups', body);
  }
  deleteSalesTaxList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/sales/tax-groups/${id}`);
  }
  updateSalesTaxList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/sales/tax-groups/${id}`, body);
  }
  //  *---------------Masterdata group-procurement-----------------*
  getGroupProcurement(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/group/procurement/approvers/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/group/procurement/approvers/list`, body);
    }
  }
  postGroupProcurement(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/group/procurement/approvers', body);
  }
  deleteGroupProcurement(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/group/procurement/approvers/${id}`);
  }
  updateGroupProcurement(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/group/procurement/approvers/${id}`, body);
  }
  //  *---------------Masterdata Group Procurement Rejection-----------------*
  getGroupProcurementRejectionList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/group/procurement/rejection/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/group/procurement/rejection/list`, body);
    }
  }
  postGroupProcurementRejection(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/group/procurement/rejection', body);
  }
  deleteGroupProcurementRejection(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/group/procurement/rejection/${id}`);
  }
  updateGroupProcurementRejection(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/group/procurement/rejection/${id}`, body);
  }

  //  *---------------Masterdata DG Rejection-----------------*
  getDataGovernanceRejectionList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/data/governance/rejection/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/data/governance/rejection/list`, body);
    }
  }
  postDataGovernanceRejection(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/data/governance/rejection', body);
  }
  deleteDataGovernanceRejection(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/data/governance/rejection/${id}`);
  }
  updateDataGovernanceRejection(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/data/governance/rejection/${id}`, body);
  }

  //  *---------------Masterdata Group Procurement Rejection-----------------*
  getRejectionReasonList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `ticket/v1/justification/reason/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `ticket/v1/justification/reason/list`, body);
    }
  }
  postRejectionReason(body: {}) {
    return this.http.post(environment.baseApiUrl + 'ticket/v1/justification/reason', body);
  }
  deleteRejectionReason(id) {
    return this.http.delete(environment.baseApiUrl + `ticket/v1/justification/reason/${id}`);
  }
  updateRejectionReason(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `ticket/v1/justification/reason/${id}`, body);
  }

  //  *---------------Masterdata Payment-----------------*
  getPaymentList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/payment/method/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/payment/method/list`, body);
    }
  }
  postPayment(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/payment/method', body);
  }
  deletePayment(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/payment/method/${id}`);
  }
  updatePayment(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/payment/method/${id}`, body);
  }
  //  *---------------Masterdata Payment Term-----------------*
  getPaymentTermList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/payment/term/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/payment/term/list`, body);
    }
  }
  postPaymentTerm(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/payment/term', body);
  }
  deletePaymentTerm(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/payment/term/${id}`);
  }
  updatePaymentTerm(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/payment/term/${id}`, body);
  }
  //  *---------------Masterdata Velocity Input Fields-----------------*
  getVelocityInputList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/velocity/input/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/velocity/input/list`, body);
    }
  }
  postVelocityInputList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/velocity/input', body);
  }
  deleteVelocityInputList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/velocity/input/${id}`);
  }
  updateVelocityInputList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/velocity/input/${id}`, body);
  }
  //  *---------------Masterdata Sertica Input Fields-----------------*
  getSerticaInputList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/sertica/input/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/sertica/input/list`, body);
    }
  }
  postSerticaInputList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/sertica/input', body);
  }
  deleteSerticaInputList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/sertica/input/${id}`);
  }
  updateSerticaInputList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/sertica/input/${id}`, body);
  }
  //  *---------------Masterdata Block request Justification reasons-----------------*
  getBlockRequestList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/block/request/justification/reasons/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/block/request/justification/reasons/list`, body);
    }
  }

  postBlockRequest(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/block/request/justification/reasons', body);
  }
  deleteBlockRequest(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/block/request/justification/reasons/${id}`);
  }
  updateBlockRequest(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/block/request/justification/reasons/${id}`, body);
  }
  //  *---------------Masterdata VIEW_ORGANISATION-----------------*
  getOrganisationList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/organisation/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/organisation/list`, body);
    }
  }
  postOrganisation(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/organisation', body);
  }
  deleteOrganisation(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/organisation/${id}`);
  }
  updateOrganisation(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/organisation/${id}`, body);
  }
  //  *---------------Masterdata Sertica Config-----------------*
  getSerticaConfigList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/sertica/units/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/sertica/units/list`, body);
    }
  }
  postSerticaConfig(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/sertica/units', body);
  }
  deleteSerticaConfig(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/sertica/units/${id}`);
  }
  updateSerticaConfig(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/sertica/units/${id}`, body);
  }
  // *---------------Masterdata LE-BU Config-----------------*
  getLeBuList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/le/bu/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/le/bu/list`, body);
    }
  }
  postLeBuList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/le/bu', body);
  }
  deleteLeBuList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/le/bu/${id}`);
  }
  updateLeBuList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/le/bu/${id}`, body);
  }
  //  *---------------Masterdata LS Input Fields-----------------*
  getLsRetailInputList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/ls/retail/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/ls/retail/list`, body);
    }
  }
  postLsRetailInputList(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/ls/retail', body);
  }
  deleteLsRetailInputList(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/ls/retail/${id}`);
  }
  updateLsRetailInputList(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/ls/retail/${id}`, body);
  }
  // *---------------Masterdata Sertica Le Fields-----------------*
  getSerticaLe(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/sertica/le/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/sertica/le/list`, body);
    }
  }
  postSerticaLe(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/sertica/le', body);
  }
  deleteSerticaLe(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/sertica/le/${id}`);
  }
  updateSerticaLe(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/sertica/le/${id}`, body);
  }


  getMasterForm(body) {
    return this.http.post(environment.baseApiUrl + `master/v1/form/fields/list`, body);
  }
  postMasterForm(body: {}) {
    return this.http.post(environment.baseApiUrl + `master/v1/form/fields`, body);
  }
  updateMasterForm(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/form/fields/${id}`, body);
  }
  deleteMasterForm(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/form/fields/${id}`);
  }

  getSerticaInputGroup(params: any) {
    return this.http.get(`${environment.baseApiUrl}master/v1/sertica/input/group`, { params });
  }
  getVelocityInputGroup(params: any) {
    return this.http.get(`${environment.baseApiUrl}master/v1/velocity/input/group`, { params });
  }
  getLsInputGroup(params: any) {
    return this.http.get(`${environment.baseApiUrl}master/v1/ls/retail/group`, { params });
  }

  // *---------------Create Ticket-----------------*
  createTicket(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/ticket`, body);
  }

  getVendorTicketDetails(id: any) {
    return this.http.get(environment.baseApiUrl + 'vendor/v1/vendor-lob-details/' + id)
  }

  getVendorTicketDetail(id: any) {
    return this.http.get(environment.baseApiUrl + 'vendor/v1/ticket-vendor-details/' + id)
  }

  subscribeMailTicket(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/ticket-email-subscription`, body);
  }
  createVendor(body: any) {
    return this.http.post(environment.baseApiUrl + `vendor/v1/line-of-business`, body);
  }

  prePopulateVelocityData(legal_entity: string, organization: string, supplier_type: string) {
    const params = new HttpParams()
      .set('legal_entity', legal_entity)
      .set('organization', organization)
      .set('supplier_type', supplier_type);

    return this.http.get(
      environment.baseApiUrl + `vendor/v1/velocity-script/retrieve`,
      { params }
    );
  }

  continueTicket(ticket_id:string) {
    return this.http.get(environment.baseApiUrl + `vendor/v1/vendor-lob-details`+`/${ticket_id}`);
  }

  checkd365duplicates(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/check-d365-duplicates`, body);
  }

  d365Check(body:any){
    return this.http.post(environment.baseApiUrl + `vendor/v1/d365-check-unblock-request`, body);
  }

  continueD365TicketRow(body){
    return this.http.post(environment.baseApiUrl + `ticket/v1/special-handle`, body);
  }

 d365CheckExtendedTicket(ticket_id: number) {
  return this.http.put(
    `${environment.baseApiUrl}ticket/v1/d365-check-extend/${ticket_id}`,
    null // No payload
  );
}
  discardTicket(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/status-change`,body);
  }

  inspectCancelTicket(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/inspect-to-cancel`, body);
  }
    inspectCompleteTicket(body: any) {
    return this.http.post(environment.baseApiUrl + `ticket/v1/inspect-to-complete`, body);
  }
  // Sales Tax Scripts
  getSalesTaxScriptsList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/list`, body);
    }
  }
  postSalesTaxScripts(body: {}) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/sales-tax-group-script', body);
  }
  deleteSalesTaxScripts(id) {
    return this.http.delete(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/${id}`);
  }
  updateSalesTaxScripts(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/${id}`, body);
  }

  // Velocity Scripts
  getVelocityScriptsList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/velocity-script/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/velocity-script/list`, body);
    }
  }
  postVelocityScripts(body: {}) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/velocity-script', body);
  }
  deleteVelocityScripts(id) {
    return this.http.delete(environment.baseApiUrl + `vendor/v1/velocity-script/${id}`);
  }
  updateVelocityScripts(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/velocity-script/${id}`, body);
  }

  // Payment method Scripts
  getPaymentMethodScriptsList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/method-of-payment-script/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/method-of-payment-script/list`, body);
    }
  }
  postPaymentMethodScripts(body: {}) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/method-of-payment-script', body);
  }
  deletePaymentMethodScripts(id) {
    return this.http.delete(environment.baseApiUrl + `vendor/v1/method-of-payment-script/${id}`);
  }
  updatePaymentMethodScripts(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/method-of-payment-script/${id}`, body);
  }
  getVendorList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/list`, body);
    }
  }
  getVelocityList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/velocity/database/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/velocity/database/list`, body);
    }
  }
  getLsReatilList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/lsretail/database/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/lsretail/database/list`, body);
    }
  }
  getSerticaList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/sertica/database/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/sertica/database/list`, body);
    }
  }

  getVendorChangeLog(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/vendor-change-logs`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/vendor-change-logs`, body);
    }
  }
  getD365VendorLogs(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/vendor/data/receiver/log/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/vendor/data/receiver/log/list`, body);
    }
  }

   getSpecialLobList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/extra/lob/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/extra/lob/list`, body);
    }
  }

  
  getD365TicketLogs(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `ticket/v1/vendor-database-ticket-log/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `ticket/v1/vendor-database-ticket-log/list`, body);
    }
  }
  downloadVendorChangeLogFile(recordId: number): Observable<any> {
    return this.http.get(environment.baseApiUrl + `vendor/v1/vendor-change-log/${recordId}`);
  }
  //Default config

  getDefaultConfigList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `configuration/v1/default/configuration/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `configuration/v1/default/configuration/list`, body);
    }
  }
  postDefaultConfig(body: {}) {
    return this.http.post(environment.baseApiUrl + 'configuration/v1/default/configuration', body);
  }
  deleteDefaultConfig(id) {
    return this.http.delete(environment.baseApiUrl + `configuration/v1/default/configuration/${id}`);
  }
  updateDefaultConfig(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `configuration/v1/default/configuration/${id}`, body);
  }

  submitAstroForm(body) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/vendor-data', body);
  }

    reopenAstroForm(body) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/reopen-request', body);
  }

  getPaymentMethodScript(bankAccountType, currency, legalEntity) {
    return this.http.get(environment.baseApiUrl + `vendor/v1/method-of-payment-script/retrieve?bank_account_type=${bankAccountType}&currency=${currency}&legal_entity=${legalEntity}`)
  }

  getSalesTaxGroupScript(countryCode, legalEntity, taxExempt="") {
    return this.http.get(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/retrieve?country_code=${countryCode}&legal_entity=${legalEntity}&tax_exempt=${taxExempt}`)
  }

  getBusinessUnitScript(countryCode, legalEntity, taxExempt) {
    return this.http.get(environment.baseApiUrl + `vendor/v1/sales-tax-group-script/retrieve?country_code=${countryCode}&legal_entity=${legalEntity}&tax_exempt=${taxExempt}`)
  }

  scanTicketAttachment(body: FormData) {
    return this.http.post(environment.baseApiUrl + 'ticket/v1/attachment/upload', body);
  }

  getStatusStat(body){
    return this.http.post(environment.baseApiUrl+'ticket/v1/status-stat',body);
  }

   //  *---------------Masterdata Error Code-----------------*
   getErrorCodeList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `ticket/v1/error_code/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `ticket/v1/error_code/list`, body);
    }
  }
  postErrorCode(body: {}) {
    return this.http.post(environment.baseApiUrl + 'ticket/v1/error_code', body);
  }
  deleteErrorCode(id) {
    return this.http.delete(environment.baseApiUrl + `ticket/v1/error_code/${id}`);
  }
  updateErrorCode(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `ticket/v1/error_code/${id}`, body);
  }
  //  *---------------Masterdata Master status-----------------*
  getMasterStatusList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `ticket/v1/master_status/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `ticket/v1/master_status/list`, body);
    }
  }
  postMasterStatus(body: {}) {
    return this.http.post(environment.baseApiUrl + 'ticket/v1/master_status', body);
  }
  deleteMasterStatus(id) {
    return this.http.delete(environment.baseApiUrl + `ticket/v1/master_status/${id}`);
  }
  updateMasterStatus(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `ticket/v1/master_status/${id}`, body);
 }

  //  *---------------Masterdata Info/Error message-----------------*
  getInfoErrorMessageList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/form/field/message/config/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/form/field/message/config/list`, body);
    }
  }
  postInfoErrorMessage(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/form/field/message/config', body);
  }
  deleteInfoErrorMessage(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/form/field/message/config/${id}`);
  }
  updateInfoErrorMessage(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/form/field/message/config/${id}`, body);
  }
  getAppConfigurationData(){
    return this.http.get<any>(environment.baseApiUrl+'configuration/app-config');
  }
  updateDescription(appConfigId:number,body:{}){
    return this.http.put(environment.baseApiUrl+'configuration/app-config/description/'+appConfigId,body);
  }
  updateAppConfiguration(body:{}){
    return this.http.post(environment.baseApiUrl+'configuration/app-config/update',body);
  }

  getVendorContacts(payload: any): Observable<any> {
    return this.http.post(environment.baseApiUrl+`vendor/v1/contacts`, payload);
   }
   getVendorAddress(payload: any): Observable<any> {
    return this.http.post(environment.baseApiUrl+`vendor/v1/addresses`, payload);
   }
   getVendorBankDetails(payload: any): Observable<any> {
    return this.http.post(environment.baseApiUrl+`vendor/v1/bank-details`, payload);
   }
   getVendorSerticaContacts(serticaId: number): Observable<any> {
        return this.http.get<any>(`${environment.baseApiUrl}vendor/v1/sertica/contact/${serticaId}`);
    }
    getConvertedKeysForD365(lobId: number): Observable<any> {
        return this.http.get<any>(`${environment.baseApiUrl}master/v1/d365-column/${lobId}`);
    }
    getEmailChangeLog(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `email/v1/email-logs`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `email/v1/email-logs`, body);
    }
  }
  getNotificationLog(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `ticket/v1/ticket-email-subscription/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `ticket/v1/ticket-email-subscription/list`, body);
    }
  }
  getUpdateRequestLog(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `vendor/v1/update-request-log`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `vendor/v1/update-request-log`, body);
    }
  }

    //  *---------------Masterdata ContactInfo-----------------*
  getContactInfoList(body, is_export: boolean = false) {
    if (is_export) {
      return this.http.post(environment.baseApiUrl + `master/v1/purpose/list`, body, { observe: 'response', responseType: 'blob' });
    } else {
      return this.http.post<any>(environment.baseApiUrl + `master/v1/purpose/list`, body);
    }
  }
  postContactInfo(body: {}) {
    return this.http.post(environment.baseApiUrl + 'master/v1/purpose', body);
  }
  deleteContactInfo(id) {
    return this.http.delete(environment.baseApiUrl + `master/v1/purpose/${id}`);
  }
  updateContactInfo(body: {}, id) {
    return this.http.put(environment.baseApiUrl + `master/v1/purpose/${id}`, body);
  }

  fetchVendorMap(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/fetch-van-map-data`,body);
  }

  fetchTargetData(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/fetch-target-data`,body);
  }
  extendRequest(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/extend-request`,body);
  }

  blockRequest(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/block-request`,body);
   }

  blockRequestD365(body:{}){
    return this.http.post(environment.baseApiUrl+'vendor/v1/block-request-d365',body);
  }

  unblockRequest(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/unblock-request`,body);
   }
   unblockRequestData(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/unblock-request-data`,body);
   }
  updateRequest(body:{}){
    return this.http.post(environment.baseApiUrl + `vendor/v1/update-request`,body);
   }

   showD365CheckDuplicates(ticketId: number){
    return this.http.get(environment.baseApiUrl + `ticket/v1/show-d365-duplicates/${ticketId}`);
   }

       // Sertica Vendor Create
  createSerticaVendor(body: any) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/sertica-vendor/', body);
  }

  // Sertica Vendor Update
  updateSerticaVendor(id: number, body: any) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/sertica-vendor/${id}/`, body);
  }
    // Velocity Vendor Create
  createVelocityVendor(body: any) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/velocity-vendor/', body);
  }

  // Velocity Vendor Update
  updateVelocityVendor(id: number, body: any) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/velocity-vendor/${id}/`, body);
  }

  // LS Retail Vendor Create
  createLSRetailVendor(body: any) {
    return this.http.post(environment.baseApiUrl + 'vendor/v1/ls-retail-vendor/', body);
  }

  // LS Retail Vendor Update
  updateLSRetailVendor(id: number, body: any) {
    return this.http.put(environment.baseApiUrl + `vendor/v1/ls-retail-vendor/${id}/`, body);
  }
}
